import React, { Fragment } from 'react';
import _ from 'lodash';

import ReactTooltip from 'react-tooltip';

import AddWordSelection from './AddWordSelection';

import helpers from 'helpers';
import { letterMapper, AnnotationTooltip } from 'helpers/annotations';

class ContentGazetter extends React.Component {
    constructor(props) {
        super(props);

        let characters = [];
        let tooltips = [];

        const { textLetter, gazetters } = props;
        if (textLetter.length && gazetters.length) {
            characters = this.createCharacters(textLetter, gazetters);
            tooltips = this.createTooltips(characters);
        }

        this.state = {
            characters,
            tooltips,

            openAddWordSelection: false,
        };

        this.onMouseUp = this.onMouseUp.bind(this);
        this.closePopover = this.closePopover.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { textLetter, gazetters } = nextProps;

        if (this.props.textLetter === nextProps.textLetter
            && _.isEqual(this.props.gazetters === nextProps.gazetters)) {
            return;
        }

        if (gazetters.length > 0) {
            const characters = this.createCharacters(textLetter, gazetters);
            const tooltips = this.createTooltips(characters);

            this.setState({
                characters,
                tooltips,
            });
        } else {
            this.setState({
                characters: undefined,
                tooltips: undefined,
            });
        }
    }

    createCharacters(textLetter, gazettersFromServer) {
        const gazetters = _.cloneDeep(gazettersFromServer);
        let characters = textLetter.split('');

        characters = characters.map((symbol, symbolPosition) => ({
            symbol,
            symbolPosition,
            style: {},
            ids: [],
            tooltipContent: [],
        }));

        gazetters.sort((first, second) => {
            if (this.props.withChildren) {
                if (first.end - first.start < second.end - second.start) {
                    return -1;
                }

                if (first.end - first.start > second.end - second.start) {
                    return 1;
                }

                return 0;
            } 
            if (first.end - first.start > second.end - second.start) {
                return -1;
            }

            if (first.end - first.start < second.end - second.start) {
                return 1;
            }

            return 0;
        });

        gazetters.forEach((g, i) => {
            for (let j = gazetters[i].start; j < gazetters[i].end; j++) {
                characters[j].style = {
                    background: gazetters[i].color,
                };

                characters[j].ids.push(gazetters[i].id);
                characters[j].tooltipContent.push({
                    gazetteerName: gazetters[i].gazetteerName,
                    gazetteerType: gazetters[i].gazetteerType,
                });
            }
        });

        return characters;
    }

    createTooltips(characters) {
        const map = new Map();
        for (const char of characters) {
            map.set(char.ids.join(''), char);
        }
        return Array.from(map.values());
    }

    onMouseUp(ev) {
        const range = helpers.getSelection(ev.target.parentNode);

        if (range.start === range.end) {
            return;
        }

        this.setState({
            openAddWordSelection: true,
            elementTarget: ev.target,
            selectedText: range.string,
        });
    }

    closePopover() {
        this.setState({
            openAddWordSelection: false,
        });
    }

    render() {
        const {
            tooltips, characters, openAddWordSelection, elementTarget, selectedText, 
        } = this.state;
        const { addNewGazetter, textLetter } = this.props;

        return (
            <Fragment>
                <AddWordSelection
                    addNewGazetter={addNewGazetter}
                    openAddWordSelection={openAddWordSelection}
                    elementTarget={elementTarget}
                    closePopover={this.closePopover}
                    selectedText={selectedText}
                />
                <div className='letter-text' onMouseUp={this.onMouseUp}>
                    {
                        characters
                            ? Array.from(letterMapper(characters))
                            : textLetter
                    }
                </div>
                <AnnotationTooltip
                    tooltips={tooltips}
                    renderTooltip={tooltip => (
                        <div className='tooltip-row'>
                            {
                                tooltip.tooltipContent.map((t, k) => (<div key={k} className='tooltip-column'>
                                    <div className='col'>{`GazetteerName - ${t.gazetteerName}, `}</div>
                                    <div className='col'>{`GazetteerType - ${t.gazetteerType}`}</div>
                                </div>))
                            }
                        </div>
                    )}
                />

            </Fragment>
        );
    }
}

export default ContentGazetter;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Content/Gazetters.jsx